import UsersSettings from './UsersSettings';

export default UsersSettings;
